(() => {
  const STORAGE_KEY = 'bff-page-loading';
  const loader = document.querySelector('[data-js-page-loader]');
  if (!loader) return;

  let hideTimer = null;

  const show = () => {
    clearTimeout(hideTimer);
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
    // Force reflow so the transition runs after un-hiding.
    void loader.offsetWidth;
    loader.classList.add('is-visible');
  };

  const hide = () => {
    loader.classList.remove('is-visible');
    loader.setAttribute('aria-hidden', 'true');
    hideTimer = setTimeout(() => {
      if (!loader.classList.contains('is-visible')) {
        loader.hidden = true;
      }
    }, 240);
  };

  const shouldHandleLink = (anchor) => {
    if (!anchor || !anchor.href) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.dataset.noPageLoader !== undefined) return false;
    if (anchor.closest('quick-view-product')) return false;
    if (anchor.closest('mobile-navigation') && anchor.getAttribute('aria-haspopup') === 'true') return false;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return false;
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return false;

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) {
      return false;
    }

    return true;
  };

  // Resume loader across full-page navigations.
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      sessionStorage.removeItem(STORAGE_KEY);
      show();
    }
  } catch (error) {
    // sessionStorage can be unavailable in private modes.
  }

  const revealPage = () => {
    // Keep a brief minimum so the mark doesn't flash.
    hideTimer = setTimeout(hide, 120);
  };

  if (document.readyState === 'complete') {
    revealPage();
  } else {
    window.addEventListener('load', revealPage, { once: true });
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hide();
  });

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor = event.target.closest('a');
      if (!shouldHandleLink(anchor)) return;

      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        // Ignore storage failures.
      }

      show();
    },
    true
  );

  window.addEventListener('beforeunload', () => {
    // Ensures the loader is visible if navigation begins without a click handler path.
    if (loader.classList.contains('is-visible')) {
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        // Ignore storage failures.
      }
    }
  });
})();
